import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCrbtiUGR6_OXW8haOoDiXlV5xzVGAb6fM",
  authDomain: "jackandjillmatric-school-db.firebaseapp.com",
  projectId: "jackandjillmatric-school-db",
  storageBucket: "jackandjillmatric-school-db.appspot.com",
  messagingSenderId: "321526004260",
  appId: "1:321526004260:web:ad504c5d38ad096438b6b1",
  measurementId: "G-H5H6T1P277"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);